<nts-label-box label="{{'PinToDashboardMenuItemShortcutModal_MenuItem_Description' | NTSTranslate}}"></nts-label-box>
<nts-base-text-box [value]="viewModel.widgetMenuItemShortcutDto.shortDescription" [maxLength]="100"
  [errorList]="viewModel.errorList" (onValueChange)="onValueChange($event)">
</nts-base-text-box>
